const HorizontalCard = () => {
    return (
        <>
            <div className="container-fluid p-0">
                {/* {asset_loading 
             ?  <div className='text-center'> <Loader /></div>
             :  */}
                <table className="table table-borderless va_middle mb-1 bg-white">
                    {/* {details
                 ?   */}
                    <tbody>
                        <tr>
                          
                            <td style={{ width: "22%" }}>
                                Asset Matrix Name : <br />
                               
                            </td>
                            <td style={{ width: "22%" }}>Asset Matrix Type : <br /><b>fghfh</b></td>
                            <td style={{ width: "17%" }} rowSpan="3" >yy : <br />
                               
                            </td>
                            <td style={{ width: "17%" }}>Site : <div className="fw-bold">jg</div></td>
                        </tr>
                   
                    </tbody>
                    {/* :  null */}
                    {/* } */}
                </table>
                {/* } */}


            </div>
        </>
    );
};

export default HorizontalCard;
